function jaShareCartFeature() {
  function bindShareCart(button) {
    const component = button.closest('.share-cart-component');
    const dialog = component?.querySelector('.share-cart-modal');
    const copyBtn = component?.querySelector('#copy-cart-link');

    if (!component || !dialog || button.dataset.shareCartBound === 'true') return;
    button.dataset.shareCartBound = 'true';

    function markCartAsShared() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'JAPPS Cart Share Link': 'true' } }),
      }).catch(() => {});
    }

    button.addEventListener('click', markCartAsShared);

    copyBtn?.addEventListener('click', async () => {
      const input = component.querySelector('#cart-permalink');
      if (!input) return;

      try {
        await navigator.clipboard.writeText(input.value);
      } catch (error) {
        input.select();
        document.execCommand('copy');
      }

      const original = copyBtn.textContent;
      copyBtn.textContent = 'Copied!';
      setTimeout(() => {
        copyBtn.textContent = original;
      }, 2000);
    });
  }

  const bindAvailableFeatures = () => {
    document.querySelectorAll('.share-cart-trigger').forEach(bindShareCart);
  };

  const pollForElements = () => {
    bindAvailableFeatures();

    if (!document.querySelector('.share-cart-trigger')) {
      setTimeout(pollForElements, 200);
    }
  };

  pollForElements();

  new MutationObserver(bindAvailableFeatures).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

jaShareCartFeature();
